import { ContainerLoading } from "./container-loading";
import { ContainerNoData } from "./container-no-data";
import { ContainerIsShow } from "./container-is-show";
import { ContainerPermission } from "./container-permission";

export const ContentConditional = {
  Loading: ContainerLoading,
  NoData: ContainerNoData,
  IsShow: ContainerIsShow,
  Permission: ContainerPermission,
};
